import personone from "../../img/p1.png"
import persontwo from "../../img/p2.png"
import personthree from "../../img/p3.png"
import personfour from "../../img/p4.png"
import personfive from "../../img/p5.png"
import personsix from "../../img/p6.png"
import "./proposal.css"
function Proposal(){
     return(
                    <>
                    <div className="proposal">
                          <div className="table">
                        <div className="start">
                            <h4>Propsal Actions</h4>
                            <div className="point">
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                        <div className="end">
                            <table className="table table-hover  rounded align-middle">
                <thead> 
                  <tr>
                    <th>Check User</th>
                    <th>Proposal</th>
                    <th>Clients</th>
                    <th></th>
                    <th>Amount</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                        <input type="checkbox" name="" id="" />
                    </td>
                    <td>#321456</td>
                    <td>
                      <img src={personone} alt="" />
                    </td>
                    <td>
                      <p>Archie Cantones</p>
                      <p>ariceh.tones@gmail.com</p>
                    </td>
                    <td>120.50 USD</td>
                    <td>11/06/2023 10:53</td>
                    <td>Compelted</td>
                    <td>      
                        <i class="fa-solid fa-paper-plane"></i>
<i class="fa-solid fa-eye"></i>   <i className="fa-solid fa-ellipsis-vertical"></i>         </td>
            
                  </tr>
                 <tr>
                    <td>
                        <input type="checkbox" name="" id="" />
                    </td>
                                        <td>#321456</td>

                    <td>
                      <img src={persontwo} alt="" />
                    </td>
                    <td>
                      <p>Holmes Cherryman</p>
                      <p>cherryman @gmail.com</p>
                    </td>
                    <td>300.00.0 USD</td>
                    <td>11/06/2023 10:53</td>
                    <td>In Progress</td>
                                <td>      
                        <i class="fa-solid fa-paper-plane"></i>
<i class="fa-solid fa-eye"></i>   <i className="fa-solid fa-ellipsis-vertical"></i>         </td>
            
                  </tr>
                   <tr>
                    <td>
                        <input type="checkbox" name="" id="" />
                    </td>
                                        <td>#321456</td>

                    <td>
                      <img src={personthree} alt="" />
                    </td>
                    <td>
                      <p>Malanie Hanvey</p>
                      <p>malan-hanvey@gmail.com</p>
                    </td>
                    <td>249.99 USD</td>
                    <td>11/06/2023 10:53</td>
                    <td>Compelted</td>
                                <td>      
                        <i class="fa-solid fa-paper-plane"></i>
<i class="fa-solid fa-eye"></i>      <i className="fa-solid fa-ellipsis-vertical"></i>      </td>
            
                  </tr>
                  <tr>
                    <td>
                        <input type="checkbox" name="" id="" />
                    </td>
                                        <td>#321456</td>

                    <td>
                      <img src={personfour} alt="" />
                    </td>
                    <td>
                      <p>Kenneth Hune</p>
                      <p>nneth.une@gmail.com</p>
                    </td>
                    <td>150.00 USD</td>
                    <td>11/06/2023 10:53</td>
                    <td>Not Intersted</td>
                                <td>      
                        <i class="fa-solid fa-paper-plane"></i>
<i class="fa-solid fa-eye"></i>      <i className="fa-solid fa-ellipsis-vertical"></i>      </td>
            
                  </tr>
                    <tr>
                        <td>
                        <input type="checkbox" name="" id="" />
                    </td>
                                        <td>#321456</td>

                    <td>
                      <img src={personfive} alt="" />
                    </td>
                    <td>
                      <p>Kennth Hune </p>
                      <p>nneth.une@gmail.com</p>
                    </td>
                    <td>249.99 USD</td>
                    <td>11/06/2023 10:53</td>
                    <td>Not Intersted</td>
                                <td>      
                        <i class="fa-solid fa-paper-plane"></i>
<i class="fa-solid fa-eye"></i>         <i className="fa-solid fa-ellipsis-vertical"></i>   </td>
                  </tr>
                  
                 
                 
                </tbody>
              </table>
                        </div>
                    </div>
                    </div>
                    </>
                )
}
export default Proposal